const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "At [Your Company Name], we value your trust and are committed to ensuring your security and privacy when using our CCTV and surveillance systems. This Privacy Policy outlines the practices we follow to protect and manage your data effectively."
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: "We collect essential data to provide and improve our security solutions, including:",
        list: [
            "Installation details and equipment specifications",
            "Footage data from installed CCTV systems",
            "User contact information for service notifications",
            "Support requests and system usage data"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: "Our Terms of Service govern the use of our CCTV and security systems. By using our services, you agree to comply with these terms, which include system usage, support obligations, and warranty conditions."
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: "You have the right to:",
        list: [
            "Access and manage your stored surveillance footage",
            "Request deletion of personal data collected during installation",
            "Review and update contact information associated with your account"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: "We employ robust security measures, such as encryption and multi-layered access controls, to protect your surveillance data from unauthorized access and breaches."
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: "Our website uses cookies to provide a seamless user experience, such as saving your login preferences and tracking analytics to enhance our service offerings."
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: "We may integrate third-party platforms, such as cloud storage providers, to store and process surveillance data. These providers are carefully vetted to ensure compliance with data protection standards."
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: "Your surveillance footage and account information are stored securely. Footage retention periods are determined based on your service plan or legal requirements. Users can request customized data storage options as needed."
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: "If required, data may be transferred to servers located in different regions for processing. All transfers comply with applicable laws to maintain the highest standards of security and privacy."
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: "We periodically update this Privacy Policy to reflect changes in our services or legal requirements. Notifications will be sent for major updates, and the latest version will always be accessible on our website."
    }
];

export default privacyPolicy;